import * as React from "react";

export const CurrencyNairaIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>(({ title, titleId, ...props }, ref) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.42857 14V6.70133C6.42852 6.54622 6.48368 6.39548 6.58537 6.27279C6.68707 6.1501 6.82954 6.06242 6.99043 6.0235C7.15131 5.98459 7.32148 5.99666 7.47422 6.0578C7.62696 6.11895 7.75361 6.22572 7.83429 6.36133L12.1657 13.6387C12.2464 13.7743 12.373 13.881 12.5258 13.9422C12.6785 14.0033 12.8487 14.0154 13.0096 13.9765C13.1705 13.9376 13.3129 13.8499 13.4146 13.7272C13.5163 13.6045 13.5715 13.4538 13.5714 13.2987V6M5 8.66667H15M5 11.3333H15"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={10} cy={10} r={9.25} stroke="currentColor" strokeWidth={1.5} />
  </svg>
));
